import { Action } from "@ngrx/store";
import { BrainstormActionTypes } from './index';
import { BranchModel, DepartmentModel, CollaboratorModel, IdeaModel } from "../../model/BrainstormModel";

export class IdeaClearAction implements Action {
    public type = BrainstormActionTypes.CLEAR;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor() { }
}

export class ListBranchesAction implements Action {
    public type = BrainstormActionTypes.LIST_BRANCHES;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { clientId: number }) { }
}

export class ListDepartmentsAction implements Action {
    public type = BrainstormActionTypes.LIST_DEPARTMENTS;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { branchId: number }) { }
}

export class ListCollaboratorsAction implements Action {
    public type = BrainstormActionTypes.LIST_COLLABORATORS;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { departmentId: number }) { }
}

export class GetCollaboratorAction implements Action {
    public type = BrainstormActionTypes.GET_COLLABORATOR;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { collaboratorId: number }) { }
}

export class ListImplementerIdeasAction implements Action {
    public type = BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { userId: number }) { }
}

export class ListCollaboratorIdeasAction implements Action {
    public type = BrainstormActionTypes.LIST_IDEAS_COLLABORATOR;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { userId: number }) { }
}

export class GetIdeaAction implements Action {
    public type = BrainstormActionTypes.GET_IDEA;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { ideaId: number }) { }
}

export class SaveIdeaAction implements Action {
    public type = BrainstormActionTypes.SAVE_IDEA;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor(public payload: { data: IdeaModel }) { }
}

export class BrainstormClearErrorsAction implements Action {
    public type = BrainstormActionTypes.CLEAR_ERRORS;
    public branchesData: Array<BranchModel>;
    public departmentsData: Array<DepartmentModel>;
    public collaboratorsData: Array<CollaboratorModel>;
    public collaboratorData: CollaboratorModel;
    public implementerIdeasData: Array<IdeaModel>;
    public collaboratorIdeasData: Array<IdeaModel>;
    public ideaData: IdeaModel;
    public errorPayload: any;
    constructor() { }
}

export type BrainstormActions = IdeaClearAction | ListBranchesAction | ListDepartmentsAction | ListCollaboratorsAction | GetCollaboratorAction | ListImplementerIdeasAction | ListCollaboratorIdeasAction | GetIdeaAction | SaveIdeaAction | BrainstormClearErrorsAction;


// WEBPACK FOOTER //
// ./src/store/action/BrainstormActions.ts